<template>
  <div class="container">
      <breadcrumb></breadcrumb>
      <!-- <b-button v-b-toggle.sidebar-right>Menu</b-button> -->
      <div class="card card--white">
          <div class="card-body">
              <div class="row">
                  <div class="col-md-12">
                      <b-alert show variant="warning" v-show="documentos && documentos.length==0">No hay Documentos en el periodo seleccionado</b-alert>

                      <div>
                        <table class="table table--secondary">
                          <thead>
                            <tr>
                               <th>
                                ID
                              </th>
                              <th>
                                N° Factura
                              </th>
                              <th>
                                Estado
                              </th>
                              <th>
                                Periodo
                              </th>
                              <th>
                                Desde
                              </th>
                              <th>
                                Hasta
                              </th>
                              <th>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="documento in documentos" v-bind:key="documento.id">
                              <td>
                                {{documento.id}}
                              </td>
                              <td>{{documento.folio}}</td>
                              <td>
                                 {{documento.estado_nombre}}
                              </td>
                              <td>{{documento.periodo | moment("MMM YYYY") }}</td>
                              <td>{{documento.desde | moment("DD MMM YYYY") }}</td>
                              <td>{{documento.hasta | moment("DD MMM YYYY")}}</td>
                              <td>

                                <span v-if="documento.loading"><i class="fa fa-spinner fa-spin"></i></span>
                                <a v-show="!documento.loading" v-if="documento.factura == null"  v-on:click="link_xls(documento)" href="#"><i class="fa fa-file-excel"></i></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
// import moment from 'moment'
// import PieChart from "@/views/PieChart.vue";
import Breadcrumb from '@/components/Breadcrumb.vue'

export default {
  name: 'Documentos',
  components: { Breadcrumb },
  props: {
    msg: String
  },
  data () {
    return {
      documentos: []
    }
  },
  methods: {
    search () {
      var self = this
      axios.get('/portal/documentos/', {
        params: {
          periodo__gte: self.$route.query.desde,
          periodo__lte: self.$route.query.hasta,
          direccion: self.$route.params.id
        }
      })
        .then(res => {
          res.data.forEach(e => { e.loading = false })
          this.documentos = res.data
        })
    },
    link_xls (documento) {
      documento.loading = true
      var url = process.env.VUE_APP_API_MAIN + '/portal/documentos/xls/' + documento.id + '/'
      axios
        .get(url, { responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Documento.xls')
          document.body.appendChild(link)
          link.click()
          documento.loading = false
        })
    }
  },
  mounted () {
    console.log(this.$route.params.id)

    this.search()
  }
}
</script>
